/* eslint-disable @typescript-eslint/no-explicit-any */
import { Flex, Typography, TextColors, FontFamilies, Toggle } from "@abel-technologies-as/components";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

export const useWeeklyDigitalColumns = ({ onToggle }: { onToggle: (id: number) => void }) => {
	const { t } = useTranslation("dhc");

	return [
		{
			field: "week",
			headerName: t("date_range"),
			width: 350,
			renderCell: (row: any) => (
				<Flex gap="6px" justifyContent="flex-start">
					<Typography
						lineHeight="20px"
						letterSpacing="0%"
						fontWeight={500}
						fontSize="14px"
						color={TextColors.Primary}
						fontFamily={FontFamilies.InterMedium}>
						{row.weekNumber}
					</Typography>
					<Typography
						lineHeight="20px"
						fontWeight={400}
						fontSize="14px"
						color={TextColors.Tertiary}
						fontFamily={FontFamilies.InterRegular}>
						{row.dateRange
							?.split(" – ")
							.map((d: string) => dayjs(d).format("DD.MM.YY"))
							.join(" – ")}
					</Typography>
				</Flex>
			),
		},
		{
			field: "product",
			headerName: t("product"),
			width: 150,
			renderCell: (row: any) => (
				<Typography fontSize="14px" color={TextColors.Secondary}>
					{row.product}
				</Typography>
			),
		},
		{
			field: "daysWorked",
			headerName: t("days_worked"),
			width: 120,
			renderCell: (row: any) => (
				<Typography fontSize="14px" color={TextColors.Secondary}>
					{row.daysWorked}
				</Typography>
			),
		},

		{
			field: "activities",
			headerName: t("activities"),
			width: 150,
			renderCell: (row: any) => (
				<Typography fontSize="14px" color={TextColors.Secondary}>
					{row.activitiesAdded ?? 0}/{row.activitiesCompleted ?? 0}
				</Typography>
			),
		},

		{
			field: "workouts",
			headerName: t("client_workouts"),
			width: 150,
			renderCell: (row: any) => (
				<Typography fontSize="14px" color={TextColors.Secondary}>
					{row.workoutsAdded ?? 0}/{row.workoutsCompleted ?? 0}
				</Typography>
			),
		},
		{
			field: "tasks",
			headerName: t("tasks"),
			width: 120,
			renderCell: (row: any) => (
				<Typography fontSize="14px" color={TextColors.Secondary}>
					{row.tasksAdded ?? 0}/{row.tasksCompleted ?? 0}
				</Typography>
			),
		},
		{
			field: "approve",
			headerName: t("approve"),
			width: 50,
			renderCell: (row: any) => {
				return (
					<Toggle
						onChange={() => onToggle(row.id)}
						checked={row.qaRating ? true : false}
						label=""
						checkedColor="rgba(27, 129, 245, 1)"
					/>
				);
			},
		},
	];
};
